import { Component, OnInit } from '@angular/core';
import { PractitionerStatus } from 'src/app/shared/enums/practitioner-status.enum';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';

@Component({
  selector: 'app-admin-practitioner-list',
  templateUrl: './admin-practitioner-list.component.html',
  styleUrls: ['./admin-practitioner-list.component.scss']
})
export class AdminPractitionerListComponent implements OnInit {
  practitioners: Practitioner[] = [];
  currentStatusFilter = PractitionerStatus.Any;

  constructor(private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    this.practitionerService.getPractitionersByStatus(PractitionerStatus.Any).then(practitioners => {
      this.practitioners = practitioners;
    });
  }

  updateByStatus(value: string) {
    this.currentStatusFilter = value as PractitionerStatus;
    this.practitionerService.getPractitionersByStatus(value).then(practitioners => {
      this.practitioners = practitioners;
    });
  }

  refreshList() {
    this.updateByStatus(this.currentStatusFilter);
  }
}
